/**
 * InfoRow — a shared "label · value" row used inside details cards
 * (Quick Facts, Program details, University details, etc.).
 *
 * Why it exists: `flex items-center justify-between` breaks visually when the
 * value wraps to 2+ lines — the short label ends up vertically centered against
 * the taller value, creating a "shifted-down" look. This component enforces
 * top-alignment + right-alignment + a fixed label column so the row always
 * renders cleanly across mobile, tablet and desktop.
 *
 * Usage:
 *   <InfoRow label="Duration" value="1 year (12 months)" />
 *   <InfoRow label="Intake" value="September (Primary), January (Limited)" />
 */
const InfoRow = ({ label, value, isDark = false, testId, className = '' }) => (
  <div
    className={`flex items-start justify-between gap-4 ${className}`}
    data-testid={testId}
  >
    <span
      className={`flex-shrink-0 ${isDark ? 'text-white/60' : 'text-slate-500'}`}
    >
      {label}
    </span>
    <span
      className={`font-medium text-right ${isDark ? 'text-white' : 'text-slate-900'}`}
    >
      {value}
    </span>
  </div>
);

export default InfoRow;
